const customBanner = document.querySelector('.custom-banner');

// Check if customBanner exists AND contains an element with [data-predictive-custom]
const hasPredictiveCustom = customBanner?.querySelector('[data-predictive-custom]');

if (hasPredictiveCustom) {

class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  // onChange() {
  //   super.onChange();
  //   const newSearchTerm = this.getQuery();
  //   if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
  //     // Remove the results when they are no longer relevant for the new search term
  //     // so they don't show up when the dropdown opens again
  //     this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
  //   }

  //   // Update the term asap, don't wait for the predictive search query to finish loading
  //   this.updateSearchForTerm(this.searchTerm, newSearchTerm);

  //   this.searchTerm = newSearchTerm;

  //   if (!this.searchTerm.length) {
  //     this.close(true);
  //     return;
  //   }

  //   this.getSearchResults(this.searchTerm);
  // }


  showMinimumWordsNotice(show) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');

    if (show) {
      this.insertMinimumWordsButton(); 
      if (searchForTextElement) {
        searchForTextElement.innerText = 'Type at least 3 words'; 
      }
    } else {
      this.removeMinimumWordsButton();  
      if (searchForTextElement) {
        searchForTextElement.innerText = 'Search for more items'; 
      }
    }
  }

  insertMinimumWordsButton() {
  const predictiveSearchContainer = this.querySelector('[data-predictive-search]');
  
  if (!predictiveSearchContainer) {
    console.error('Predictive search container not found!');
    return; 
  }

  if (!this.querySelector('.predictive-search__item--term')) {
    const buttonHTML = `
      <button class="predictive-search__item predictive-search__item--term link link--text h4 animate-arrow" tabindex="-1" role="option" aria-selected="false">
        <span data-predictive-search-search-for-text="">Type at least 3 words</span>
      </button>
    `;
    
    predictiveSearchContainer.insertAdjacentHTML('beforeend', buttonHTML);  // Add the button
  }
}



  removeMinimumWordsButton() {
    const button = this.querySelector('.predictive-search__item--term');
    if (button) {
      button.remove();
    }
  }

  onKeyup(event) {
    const query = this.getQuery();
    event.preventDefault();

    if (query.length < 3) {
      this.showMinimumWordsNotice(true);  
      this.closeResults(true); 
      this.open(); 
      return; 
    }

    this.showMinimumWordsNotice(false);
    clearTimeout(this.debounceTimer);  
    this.debounceTimer = setTimeout(() => {
      this.getSearchResults(query);  
    }, 300);
  }


  // onChange() {
  //   super.onChange();
  //   const newSearchTerm = this.getQuery();

  //   // if (newSearchTerm.length === 0) {
  //   //   this.close();  // Close the modal
  //   //   return;  
  //   // }

  //   const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');

  //   if (newSearchTerm.length < 3) {
  //     this.showMinimumWordsNotice(true);
  //     this.closeResults(true); 

  //     this.open();  

  //     return;  
  //   }

  //   this.getSearchResults(newSearchTerm);

  //   if (searchForTextElement) {
  //     searchForTextElement.innerText = 'Search for more items';  // Reset original button text
  //   }

  //   this.searchTerm = newSearchTerm;
  // }

  onChange() {
  super.onChange();
  const newSearchTerm = this.getQuery();

  // Check if the input is inside the .banner-section
  const isInBannerSection = this.closest('.custom-banner');

  // If inside .banner-section, apply custom behavior
  if (isInBannerSection) {
    // If the input is empty, close the modal for .banner-section
    if (newSearchTerm.length === 0) {
      this.close();  // Close the modal
      this.closeResults(true);
      return;  // Stop further actions
    }

    // Check if the user typed less than 3 characters in .banner-section
    if (newSearchTerm.length < 3) {
      // Show the message: Enter at least 3 words
      this.showMinimumWordsNotice(true);  // Show the notice and button
      this.closeResults(true);  // Close results but keep the search modal open
      this.open();  // Keep the search modal open

      return;  // Stop further actions, don't fetch search results
    }
  }

  // Default behavior: When the user types 3 or more characters, fetch results as usual
  this.getSearchResults(newSearchTerm);

  // If it's inside .banner-section, reset the button text to the original state when search term is valid
  if (isInBannerSection) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    if (searchForTextElement) {
      searchForTextElement.innerText = 'Search for more items';  // Reset button text
    }
  }

  this.searchTerm = newSearchTerm;
}


  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  // onKeyup(event) {
  //   if (!this.getQuery().length) this.close(true);
  //   event.preventDefault();

  //   switch (event.code) {
  //     case 'ArrowUp':
  //       this.switchOption('up');
  //       break;
  //     case 'ArrowDown':
  //       this.switchOption('down');
  //       break;
  //     case 'Enter':
  //       this.selectOption();
  //       break;
  //   }
  // }

 onKeyup(event) {
  const query = this.getQuery();
  event.preventDefault();

  // Check if the input is inside the .banner-section
  const isInBannerSection = this.closest('.banner-section');

  // If inside .banner-section, apply custom behavior
  if (isInBannerSection) {
    if (query.length < 3) {
      // Show the notice to the user about entering at least 3 characters
      this.showMinimumWordsNotice(true); // Show the notice
      this.closeResults(false); // Keep the input value intact and prevent showing results
      this.open(); // Keep the modal open
      return; // Do not proceed with fetching search results
    }

    // Hide the notice once the user has entered enough characters
    this.showMinimumWordsNotice(false);
    
    // Proceed with debouncing the search as usual for valid input
    clearTimeout(this.debounceTimer); // Clear any previous debounce timer
    this.debounceTimer = setTimeout(() => {
      this.getSearchResults(query); // Perform search after a short delay
    }, 300); // 300ms debounce delay
  } else {
    // Default behavior for inputs outside .banner-section (search results are shown as usual)
    clearTimeout(this.debounceTimer);  // Use the class-level debounceTimer
    this.debounceTimer = setTimeout(() => {
      this.getSearchResults(query);  // Perform search after a short delay
    }, 300);  // Adjust debounce delay as needed (300ms)

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }
}


  


  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  // getSearchResults(searchTerm) {
  //   const queryKey = searchTerm.replace(' ', '-').toLowerCase();
  //   this.setLiveRegionLoadingState();

  //   if (this.cachedResults[queryKey]) {
  //     this.renderSearchResults(this.cachedResults[queryKey]);
  //     return;
  //   }

  //   fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
  //     signal: this.abortController.signal,
  //   })
  //     .then((response) => {
  //       if (!response.ok) {
  //         var error = new Error(response.status);
  //         this.close();
  //         throw error;
  //       }

  //       return response.text();
  //     })
  //     .then((text) => {
  //       const resultsMarkup = new DOMParser()
  //         .parseFromString(text, 'text/html')
  //         .querySelector('#shopify-section-predictive-search').innerHTML;
  //       // Save bandwidth keeping the cache in all instances synced
  //       this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
  //         predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
  //       });
  //       this.renderSearchResults(resultsMarkup);
  //     })
  //     .catch((error) => {
  //       if (error?.code === 20) {
  //         // Code 20 means the call was aborted
  //         return;
  //       }
  //       this.close();
  //       throw error;
  //     });
  // }

    getSearchResults(searchTerm) {
      // Don't fetch results if the search term is less than 3 characters
      if (searchTerm.length < 3) {
        return; // Exit early and do nothing if the term is too short
      }

      const queryKey = searchTerm.replace(' ', '-').toLowerCase();
      this.setLiveRegionLoadingState();

      if (this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        return;
      }

      fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
        signal: this.abortController.signal,
      })
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search').innerHTML;
          // Save bandwidth keeping the cache in all instances synced
          this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
          });
          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          if (error?.code === 20) {
            // Code 20 means the call was aborted
            return;
          }
          this.close();
          throw error;
        });
    }


  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }


  getPopupResultsMaxHeight() {
    const popup = document.querySelector('#search-popup');  // target only this popup
    if (!popup) return;

    // Check if popup is visible (not display:none, hidden, or opacity 0)
    const popupStyle = window.getComputedStyle(popup);
    if (
      popupStyle.display === 'none' ||
      popupStyle.visibility === 'hidden' ||
      popupStyle.opacity === '0'
    ) {
      // Popup is hidden; do not apply height or log
      return;
    }

    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;

    let bottomSpace;

    if (viewportWidth < 550) {
      bottomSpace = 180;
    } else if (viewportWidth < 769) {
      bottomSpace = 500;
    } else {
      bottomSpace = 400;
    }


    // Set max-height for predictive search results
    const resultsEl = popup.querySelector('.predictive-search__results');
    if (resultsEl) {
      resultsEl.style.maxHeight = `${viewportHeight - bottomSpace}px`;
      console.log('[#search-popup] Set max-height for results:', viewportHeight - bottomSpace);
    }

    // Set max-height for metaobject-product-blog-list
    const metaobjectEl = popup.querySelector('.metaobject-product-blog-list');
    if (metaobjectEl) {
      metaobjectEl.style.maxHeight = `${viewportHeight - bottomSpace}px`;
      console.log('[#search-popup] Set max-height for metaobject-product-blog-list:', viewportHeight - bottomSpace);
    }

    console.log('[#search-popup] Viewport height:', viewportHeight);
    console.log('[#search-popup] Bottom space reserved:', bottomSpace);

    return viewportHeight - bottomSpace;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  open() {
    this.predictiveSearchResults.style.height = this.resultsMaxHeight || `${this.getPopupResultsMaxHeight()}px`;
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getPopupResultsMaxHeight()}px`;

    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }
  
  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      // this.input.value = '';
      // this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);

(function () {
  const popup = document.querySelector('#search-popup');
  if (!popup) return;

  const updatePopupHeights = () => {
    const inst = popup.querySelector('predictive-search');
    if (inst && typeof inst.getPopupResultsMaxHeight === 'function') {
      inst.getPopupResultsMaxHeight(true);
    }
  };

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'attributes' && (m.attributeName === 'class' || m.attributeName === 'style' || m.attributeName === 'open')) {
        const style = window.getComputedStyle(popup);
        if (style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0') {
          setTimeout(updatePopupHeights, 120);
        }
      } else if (m.type === 'childList') {
        setTimeout(updatePopupHeights, 120);
      }
    }
  });

  observer.observe(popup, { attributes: true, attributeFilter: ['class','style','open'], childList: true });

  // window.addEventListener('load', () => setTimeout(updatePopupHeights, 80));
  window.addEventListener('resize', () => setTimeout(updatePopupHeights, 120));
})();



} else {

  
class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }


  showMinimumWordsNotice(show) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');

    if (show) {
      this.insertMinimumWordsButton(); 
      if (searchForTextElement) {
        searchForTextElement.innerText = 'Type at least 3 words'; 
      }
    } else {
      this.removeMinimumWordsButton();  
      if (searchForTextElement) {
        searchForTextElement.innerText = 'Search for more items'; 
      }
    }
  }

  insertMinimumWordsButton() {
  const predictiveSearchContainer = this.querySelector('[data-predictive-search]');
  
  if (!predictiveSearchContainer) {
    console.error('Predictive search container not found!');
    return; 
  }

  if (!this.querySelector('.predictive-search__item--term')) {
    const buttonHTML = `
      <button class="predictive-search__item predictive-search__item--term link link--text h4 animate-arrow" tabindex="-1" role="option" aria-selected="false">
        <span data-predictive-search-search-for-text="">Type at least 3 words</span>
      </button>
    `;
    
    predictiveSearchContainer.insertAdjacentHTML('beforeend', buttonHTML);  // Add the button
  }
}



  removeMinimumWordsButton() {
    const button = this.querySelector('.predictive-search__item--term');
    if (button) {
      button.remove();
    }
  }

  onKeyup(event) {
    const query = this.getQuery();
    event.preventDefault();

    if (query.length < 3) {
      this.showMinimumWordsNotice(true);  
      this.closeResults(true); 
      this.open(); 
      return; 
    }

    this.showMinimumWordsNotice(false);
    clearTimeout(this.debounceTimer);  
    this.debounceTimer = setTimeout(() => {
      this.getSearchResults(query);  
    }, 300);
  }


  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }


  


  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  


  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }


  getPopupResultsMaxHeight() {
    const popup = document.querySelector('#search-popup');  // target only this popup
    if (!popup) return;

    // Check if popup is visible (not display:none, hidden, or opacity 0)
    const popupStyle = window.getComputedStyle(popup);
    if (
      popupStyle.display === 'none' ||
      popupStyle.visibility === 'hidden' ||
      popupStyle.opacity === '0'
    ) {
      // Popup is hidden; do not apply height or log
      return;
    }

    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;

    let bottomSpace;

    if (viewportWidth < 550) {
      bottomSpace = 180;
    } else if (viewportWidth < 769) {
      bottomSpace = 500;
    } else {
      bottomSpace = 400;
    }


    // Set max-height for predictive search results
    const resultsEl = popup.querySelector('.predictive-search__results');
    if (resultsEl) {
      resultsEl.style.maxHeight = `${viewportHeight - bottomSpace}px`;
      console.log('[#search-popup] Set max-height for results:', viewportHeight - bottomSpace);
    }

    // Set max-height for metaobject-product-blog-list
    const metaobjectEl = popup.querySelector('.metaobject-product-blog-list');
    if (metaobjectEl) {
      metaobjectEl.style.maxHeight = `${viewportHeight - bottomSpace}px`;
      console.log('[#search-popup] Set max-height for metaobject-product-blog-list:', viewportHeight - bottomSpace);
    }

    console.log('[#search-popup] Viewport height:', viewportHeight);
    console.log('[#search-popup] Bottom space reserved:', bottomSpace);

    return viewportHeight - bottomSpace;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  open() {
    this.predictiveSearchResults.style.height = this.resultsMaxHeight || `${this.getPopupResultsMaxHeight()}px`;
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getPopupResultsMaxHeight()}px`;

    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }
  
  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);

(function () {
  const popup = document.querySelector('#search-popup');
  if (!popup) return;

  const updatePopupHeights = () => {
    const inst = popup.querySelector('predictive-search');
    if (inst && typeof inst.getPopupResultsMaxHeight === 'function') {
      inst.getPopupResultsMaxHeight(true);
    }
  };

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'attributes' && (m.attributeName === 'class' || m.attributeName === 'style' || m.attributeName === 'open')) {
        const style = window.getComputedStyle(popup);
        if (style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0') {
          setTimeout(updatePopupHeights, 120);
        }
      } else if (m.type === 'childList') {
        // popup content changed/inserted
        setTimeout(updatePopupHeights, 120);
      }
    }
  });

  observer.observe(popup, { attributes: true, attributeFilter: ['class','style','open'], childList: true });

  // window.addEventListener('load', () => setTimeout(updatePopupHeights, 80));
  window.addEventListener('resize', () => setTimeout(updatePopupHeights, 120));
})();


}


// const customBanner = document.querySelector(".custom-banner");

// // Check if customBanner exists AND contains an element with [data-predictive-custom]
// const hasPredictiveCustom = customBanner?.querySelector(
//   "[data-predictive-custom]"
// );

// // Create a custom attribute on the predictive search instances to identify them
// if (hasPredictiveCustom) {
//   const bannerPredictiveSearch = customBanner.querySelector("predictive-search");
//   if (bannerPredictiveSearch) {
//     bannerPredictiveSearch.setAttribute("data-custom-banner-search", "");
//   }
// }

// class PredictiveSearch extends SearchForm {
//   constructor() {
//     super();
//     this.cachedResults = {};
//     this.predictiveSearchResults = this.querySelector(
//       "[data-predictive-search]"
//     );
//     this.allPredictiveSearchInstances =
//       document.querySelectorAll("predictive-search");
//     this.isOpen = false;
//     this.abortController = new AbortController();
//     this.searchTerm = "";

//     this.setupEventListeners();
//   }

//   setupEventListeners() {
//     this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));

//     this.input.addEventListener("focus", this.onFocus.bind(this));
//     this.addEventListener("focusout", this.onFocusOut.bind(this));
//     this.addEventListener("keyup", this.onKeyup.bind(this));
//     this.addEventListener("keydown", this.onKeydown.bind(this));
//   }

//   getQuery() {
//     return this.input.value.trim();
//   }

//   onChange() {
//     super.onChange();
//     const newSearchTerm = this.getQuery();
//     const isBannerSearch = this.hasAttribute("data-custom-banner-search");

//     if (isBannerSearch) {
//       // Banner search specific behavior
//       if (newSearchTerm.length === 0) {
//         this.close();
//         this.closeResults(true);
//         return;
//       }

//       if (newSearchTerm.length < 3) {
//         this.showMinimumWordsNotice(true);
//         this.closeResults(false); // Changed from true to false to prevent clearing input
//         this.open();
//         return;
//       }

//       this.showMinimumWordsNotice(false);
//     } else {
//       // Popup search - simpler behavior
//       if (newSearchTerm.length === 0) {
//         this.close();
//         this.closeResults(true);
//         return;
//       }

//       // Immediately show results for popup search
//       this.getSearchResults(newSearchTerm);
//     }

//     this.searchTerm = newSearchTerm;
//   }

//   showMinimumWordsNotice(show) {
//     const searchForTextElement = this.querySelector(
//       "[data-predictive-search-search-for-text]"
//     );

//     if (show) {
//       this.insertMinimumWordsButton();
//       if (searchForTextElement) {
//         searchForTextElement.innerText = "Type at least 3 words";
//       }
//     } else {
//       this.removeMinimumWordsButton();
//       if (searchForTextElement) {
//         searchForTextElement.innerText = "Search for more items";
//       }
//     }
//   }

//   insertMinimumWordsButton() {
//     const predictiveSearchContainer = this.querySelector(
//       "[data-predictive-search]"
//     );

//     if (!predictiveSearchContainer) {
//       console.error("Predictive search container not found!");
//       return;
//     }

//     if (!this.querySelector(".predictive-search__item--term")) {
//       const buttonHTML = `
//       <button class="predictive-search__item predictive-search__item--term link link--text h4 animate-arrow" tabindex="-1" role="option" aria-selected="false">
//         <span data-predictive-search-search-for-text="">Type at least 3 words</span>
//       </button>
//     `;

//       predictiveSearchContainer.insertAdjacentHTML("beforeend", buttonHTML); // Add the button
//     }
//   }

//   removeMinimumWordsButton() {
//     const button = this.querySelector(".predictive-search__item--term");
//     if (button) {
//       button.remove();
//     }
//   }

//   onKeyup(event) {
//     const query = this.getQuery();
//     const isBannerSearch = this.hasAttribute("data-custom-banner-search");

//     event.preventDefault();

//     if (isBannerSearch) {
//       if (query.length < 3) {
//         this.showMinimumWordsNotice(true);
//         this.closeResults(false); // Changed from true to false
//         this.open();
//         return;
//       }
//       this.showMinimumWordsNotice(false);
//     }

//     // Debounce search for both instances but with different timing
//     clearTimeout(this.debounceTimer);
//     this.debounceTimer = setTimeout(() => {
//       this.getSearchResults(query);
//     }, isBannerSearch ? 300 : 100); // Faster response for popup

//     // Handle keyboard navigation
//     switch (event.code) {
//       case "ArrowUp":
//         this.switchOption("up");
//         break;
//       case "ArrowDown":
//         this.switchOption("down");
//         break;
//       case "Enter":
//         this.selectOption();
//         break;
//     }
//   }

//   // onChange() {
//   //   super.onChange();
//   //   const newSearchTerm = this.getQuery();

//   //   // if (newSearchTerm.length === 0) {
//   //   //   this.close();  // Close the modal
//   //   //   return;
//   //   // }

//   //   const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');

//   //   if (newSearchTerm.length < 3) {
//   //     this.showMinimumWordsNotice(true);
//   //     this.closeResults(true);

//   //     this.open();

//   //     return;
//   //   }

//   //   this.getSearchResults(newSearchTerm);

//   //   if (searchForTextElement) {
//   //     searchForTextElement.innerText = 'Search for more items';  // Reset original button text
//   //   }

//   //   this.searchTerm = newSearchTerm;
//   // }

//   onFormSubmit(event) {
//     if (
//       !this.getQuery().length ||
//       this.querySelector('[aria-selected="true"] a')
//     )
//       event.preventDefault();
//   }

//   onFormReset(event) {
//     super.onFormReset(event);
//     if (super.shouldResetForm()) {
//       this.searchTerm = "";
//       this.abortController.abort();
//       this.abortController = new AbortController();
//       this.closeResults(true);
//     }
//   }

//   onFocus() {
//     const currentSearchTerm = this.getQuery();

//     if (!currentSearchTerm.length) return;

//     if (this.searchTerm !== currentSearchTerm) {
//       // Search term was changed from other search input, treat it as a user change
//       this.onChange();
//     } else if (this.getAttribute("results") === "true") {
//       this.open();
//     } else {
//       this.getSearchResults(this.searchTerm);
//     }
//   }

//   onFocusOut() {
//     setTimeout(() => {
//       if (!this.contains(document.activeElement)) this.close();
//     });
//   }

//   // onKeyup(event) {
//   //   if (!this.getQuery().length) this.close(true);
//   //   event.preventDefault();

//   //   switch (event.code) {
//   //     case 'ArrowUp':
//   //       this.switchOption('up');
//   //       break;
//   //     case 'ArrowDown':
//   //       this.switchOption('down');
//   //       break;
//   //     case 'Enter':
//   //       this.selectOption();
//   //       break;
//   //   }
//   // }

//   onKeydown(event) {
//     // Prevent the cursor from moving in the input when using the up and down arrow keys
//     if (event.code === "ArrowUp" || event.code === "ArrowDown") {
//       event.preventDefault();
//     }
//   }

//   updateSearchForTerm(previousTerm, newTerm) {
//     const searchForTextElement = this.querySelector(
//       "[data-predictive-search-search-for-text]"
//     );
//     const currentButtonText = searchForTextElement?.innerText;
//     if (currentButtonText) {
//       if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
//         // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
//         return;
//       }
//       const newButtonText = currentButtonText.replace(previousTerm, newTerm);
//       searchForTextElement.innerText = newButtonText;
//     }
//   }

//   switchOption(direction) {
//     if (!this.getAttribute("open")) return;

//     const moveUp = direction === "up";
//     const selectedElement = this.querySelector('[aria-selected="true"]');

//     // Filter out hidden elements (duplicated page and article resources) thanks
//     // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
//     const allVisibleElements = Array.from(
//       this.querySelectorAll("li, button.predictive-search__item")
//     ).filter((element) => element.offsetParent !== null);
//     let activeElementIndex = 0;

//     if (moveUp && !selectedElement) return;

//     let selectedElementIndex = -1;
//     let i = 0;

//     while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
//       if (allVisibleElements[i] === selectedElement) {
//         selectedElementIndex = i;
//       }
//       i++;
//     }

//     this.statusElement.textContent = "";

//     if (!moveUp && selectedElement) {
//       activeElementIndex =
//         selectedElementIndex === allVisibleElements.length - 1
//           ? 0
//           : selectedElementIndex + 1;
//     } else if (moveUp) {
//       activeElementIndex =
//         selectedElementIndex === 0
//           ? allVisibleElements.length - 1
//           : selectedElementIndex - 1;
//     }

//     if (activeElementIndex === selectedElementIndex) return;

//     const activeElement = allVisibleElements[activeElementIndex];

//     activeElement.setAttribute("aria-selected", true);
//     if (selectedElement) selectedElement.setAttribute("aria-selected", false);

//     this.input.setAttribute("aria-activedescendant", activeElement.id);
//   }

//   selectOption() {
//     const selectedOption = this.querySelector(
//       '[aria-selected="true"] a, button[aria-selected="true"]'
//     );

//     if (selectedOption) selectedOption.click();
//   }

//   getSearchResults(searchTerm) {

//      // Prevent API call if searchTerm is empty or only whitespace
//     if (!searchTerm || searchTerm.trim().length === 0) {
//       this.close();
//       return;
//     }
//     const isBannerSearch = this.hasAttribute("data-custom-banner-search");

//     // Only apply 3-character minimum for banner search
//     if (isBannerSearch && searchTerm.length < 3) {
//       return;
//     }

//     const queryKey = searchTerm.replace(" ", "-").toLowerCase();
//     this.setLiveRegionLoadingState();

//     if (this.cachedResults[queryKey]) {
//       this.renderSearchResults(this.cachedResults[queryKey]);
//       return;
//     }

//     fetch(
//       `${routes.predictive_search_url}?q=${encodeURIComponent(
//         searchTerm
//       )}&section_id=predictive-search`,
//       {
//         signal: this.abortController.signal,
//       }
//     )
//       .then((response) => {
//         if (!response.ok) {
//           this.close();
//           // Don't throw error for 422 status (empty query)
//           if (response.status === 422) {
//             return null;
//           }
//           throw new Error(response.status);
//         }
//         return response.text();
//       })
//       .then((text) => {
//         if (!text) return; // Handle null response from 422 status

//         const resultsMarkup = new DOMParser()
//           .parseFromString(text, "text/html")
//           .querySelector("#shopify-section-predictive-search").innerHTML;

//         this.allPredictiveSearchInstances.forEach(
//           (predictiveSearchInstance) => {
//             predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
//           }
//         );
//         this.renderSearchResults(resultsMarkup);
//       })
//       .catch((error) => {
//         if (error?.code === 20) {
//           // Code 20 means the call was aborted
//           return;
//         }
//         console.error('Predictive search error:', error);
//         this.close();
//       });
//   }

//   setLiveRegionLoadingState() {
//     this.statusElement =
//       this.statusElement || this.querySelector(".predictive-search-status");
//     this.loadingText =
//       this.loadingText || this.getAttribute("data-loading-text");

//     this.setLiveRegionText(this.loadingText);
//     this.setAttribute("loading", true);
//   }

//   setLiveRegionText(statusText) {
//     this.statusElement.setAttribute("aria-hidden", "false");
//     this.statusElement.textContent = statusText;

//     setTimeout(() => {
//       this.statusElement.setAttribute("aria-hidden", "true");
//     }, 1000);
//   }

//   renderSearchResults(resultsMarkup) {
//     this.predictiveSearchResults.innerHTML = resultsMarkup;
//     this.setAttribute("results", true);

//     this.setLiveRegionResults();
//     this.open();
//   }

//   setLiveRegionResults() {
//     this.removeAttribute("loading");
//     this.setLiveRegionText(
//       this.querySelector("[data-predictive-search-live-region-count-value]")
//         .textContent
//     );
//   }

//   getResultsMaxHeight() {
//     this.resultsMaxHeight =
//       window.innerHeight -
//       document.querySelector(".section-header")?.getBoundingClientRect()
//         .bottom;
//     return this.resultsMaxHeight;
//   }

//   getPopupResultsMaxHeight() {
//     const popup = document.querySelector("#search-popup"); // target only this popup
//     if (!popup) return;

//     // Check if popup is visible (not display:none, hidden, or opacity 0)
//     const popupStyle = window.getComputedStyle(popup);
//     if (
//       popupStyle.display === "none" ||
//       popupStyle.visibility === "hidden" ||
//       popupStyle.opacity === "0"
//     ) {
//       // Popup is hidden; do not apply height or log
//       return;
//     }

//     const viewportHeight = window.innerHeight;
//     const viewportWidth = window.innerWidth;

//     let bottomSpace;

//     if (viewportWidth < 550) {
//       bottomSpace = 180;
//     } else if (viewportWidth < 769) {
//       bottomSpace = 500;
//     } else {
//       bottomSpace = 400;
//     }

//     // Set max-height for predictive search results
//     const resultsEl = popup.querySelector(".predictive-search__results");
//     if (resultsEl) {
//       resultsEl.style.maxHeight = `${viewportHeight - bottomSpace}px`;
//       console.log(
//         "[#search-popup] Set max-height for results:",
//         viewportHeight - bottomSpace
//       );
//     }

//     // Set max-height for metaobject-product-blog-list
//     const metaobjectEl = popup.querySelector(".metaobject-product-blog-list");
//     if (metaobjectEl) {
//       metaobjectEl.style.maxHeight = `${viewportHeight - bottomSpace}px`;
//       console.log(
//         "[#search-popup] Set max-height for metaobject-product-blog-list:",
//         viewportHeight - bottomSpace
//       );
//     }

//     console.log("[#search-popup] Viewport height:", viewportHeight);
//     console.log("[#search-popup] Bottom space reserved:", bottomSpace);

//     return viewportHeight - bottomSpace;
//   }

//   open() {
//     this.predictiveSearchResults.style.height =
//       this.resultsMaxHeight || `${this.getPopupResultsMaxHeight()}px`;
//     this.predictiveSearchResults.style.maxHeight =
//       this.resultsMaxHeight || `${this.getPopupResultsMaxHeight()}px`;

//     this.setAttribute("open", true);
//     this.input.setAttribute("aria-expanded", true);
//     this.isOpen = true;
//   }

//   close(clearSearchTerm = false) {
//     this.closeResults(clearSearchTerm);
//     this.isOpen = false;
//   }

//   closeResults(clearSearchTerm = false) {
//     const isBannerSearch = this.hasAttribute("data-custom-banner-search");

//     // Only clear input if explicitly requested AND it's the correct instance
//     if (clearSearchTerm && ((isBannerSearch && this.getQuery().length === 0) || !isBannerSearch)) {
//       this.input.value = "";
//       this.removeAttribute("results");
//     }

//     const selected = this.querySelector('[aria-selected="true"]');
//     if (selected) selected.setAttribute("aria-selected", false);

//     this.input.setAttribute("aria-activedescendant", "");
//     this.removeAttribute("loading");
//     this.removeAttribute("open");
//     this.input.setAttribute("aria-expanded", false);
//     this.resultsMaxHeight = false;
//     this.predictiveSearchResults.removeAttribute("style");
//   }
// }

// customElements.define("predictive-search", PredictiveSearch);
